<template>
    <div class="py-4 container-fluid">
        <section>
            <div class="text-right">
                <button class="btn btn-sm tnkc-secondary" @click="goBack">
                    <font-awesome-icon icon="undo"/>
                    Go Back
                </button>
            </div>
            <div class="card mt-2">
                <div class="card-body">
                    <div class="card-title">
                        details
                    </div>
                </div>
            </div>
        </section>

        <section class="mt-2">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <!-- hotel -->
                        <div class="col-md-4">
                            <div class="card">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="row">
                                                <div class="col-md-6 font-weight-bold text-center">
                                                    FLOORS
                                                </div>

                                                <div class="col-md-3">
                                                    <!-- todo modal here. -->
                                                    <button class="btn btn-sm tnkc-primary" data-toggle="modal" data-target="#newFloor" data-backdrop="static" data-keyboard="true">
                                                        <font-awesome-icon icon="plus" class="mr-1"/>
                                                        <small>ADD</small>
                                                    </button>
                                                </div>

                                              <div class="col-md-3">
                                                <button class="btn btn-sm tnkc-primary" v-on:click="create_pent_house">
                                                  <font-awesome-icon icon="plus" class="mr-1"/>
                                                  <small>PH</small>
                                                </button>
                                              </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card-body">
                                    <div class="container" v-bind:class="setFloorScrollable">
                                        <div class="card mt-2 font-weight-bold" v-for="(floor,index) in floors" :key="floor.id">
                                            <!--                                       <div class="card-title"></div>-->
                                            <div class="card-body p-1" v-bind:class="isActiveOrNotCard(floor.status)">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="row">
                                                            <div class="col-md-8">
                                                                <font-awesome-icon icon="circle"/>
                                                                {{floor.name.toUpperCase()}}
                                                            </div>
                                                            <div class="col-md-4">
                                                                <div class="row">
                                                                    <div class="col-md-2">
                                                                        <button class="btn tnkc-warning border-0 p-1 mr-2" @click="getFloorDetails(floor.id)" data-toggle="modal" data-target="#floor" data-backdrop="static" data-keyboard="true">
                                                                            <font-awesome-icon icon="edit"/>
                                                                        </button>
                                                                    </div>

                                                                    <div class="col-md-2">
                                                                        <button class="btn tnkc-primary border-0 p-1" v-if="floor.status" @click="get_floor_rooms(floor.id)">
                                                                            <font-awesome-icon icon="arrow-right"/>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Rooms -->
                        <div class="col-md-4" v-if="floor.id != undefined">
                            <div class="card">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="row">
                                                <div class="col-md-6 font-weight-bold">
                                                    [ {{floor.code ? floor.code.toUpperCase() : ''}} ]  ROOMS

                                                </div>

                                                <div class="col-md-6">
                                                    <button class="btn btn-sm tnkc-primary" data-toggle="modal" data-target="#newRoom" data-backdrop="static" data-keyboard="true" v-if="floor.status">
                                                        <font-awesome-icon icon="plus" class="mr-1"/>
                                                        ADD
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card-body">
                                    <div class="container" v-bind:class="setRoomScrollable">
                                        <div class="card mt-2" v-for="room in rooms" :key="room.id">
                                            <!--<div class="card-title"></div>-->
                                            <div class="card-body p-1" v-bind:class="isActiveOrNotCard(room.status)">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="row">
                                                            <div class="col-md-8">
                                                                <font-awesome-icon icon="circle"/>
                                                                {{room.code ? room.name.toUpperCase() : ''}}
                                                            </div>
                                                            <div class="col-md-4">
                                                               <div class="row">
                                                                   <div class="col-md-2">
                                                                       <button class="btn tnkc-warning border-0 p-1 mr-2" @click="view_room(room.id)" data-toggle="modal" data-target="#room" data-backdrop="static" data-keyboard="true">
                                                                           <font-awesome-icon icon="edit"/>
                                                                       </button>
                                                                   </div>
                                                                   <div class="col-md-2">
                                                                       <button class="btn tnkc-primary border-0 p-1" v-if="room.status" @click="get_bed_rooms(room.id)">
                                                                           <font-awesome-icon icon="arrow-right"/>
                                                                       </button>
                                                                   </div>
                                                               </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <!-- bed -->
                        <div class="col-md-4" v-if="room.id != undefined || beds.length != 0">
                            <div class="card">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="row">
                                                <div class="col-md-6 font-weight-bold">
                                                    [ {{room.name ? room.name.toUpperCase() : ''}} ]  BEDS
                                                </div>

                                                <div class="col-md-6">
                                                    <button class="btn btn-sm tnkc-primary" data-toggle="modal" data-target="#newBed" data-backdrop="static" data-keyboard="true">
                                                        <font-awesome-icon icon="plus"/>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <!-- rooms -->
                                <div class="card-body">
                                    <div class="container" v-bind:class="setBedRoomScrollable">
                                        <div class="card mt-2" v-for="bed in beds" :key="bed.id">
                                            <div class="card-body p-1"  v-bind:class="isActiveOrNotCard(bed.status)">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="row">
                                                            <div class="col-md-8">
                                                                <font-awesome-icon icon="circle"/>
                                                                {{bed.code ? bed.name.toUpperCase() : ''}}
                                                            </div>
                                                            <div class="col-md-4">
                                                                <div class="row">
                                                                    <div class="col-md-2">
                                                                        <button class="btn tnkc-warning border-0 p-1 mr-2" @click="view_bed(bed.id)" data-toggle="modal" data-target="#bed" data-backdrop="static" data-keyboard="true">
                                                                            <font-awesome-icon icon="edit"/>
                                                                        </button>
                                                                    </div>

                                                                  <div class="col-md-2">
                                                                    <button class="btn tnkc-danger border-0 p-1 mr-2" v-on:click="delete_bed(bed.id)">
                                                                      <font-awesome-icon icon="trash"/>
                                                                    </button>
                                                                  </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Modal new floor -->
        <div class="modal fade" id="newFloor" tabindex="-1" role="dialog" aria-labelledby="newFloorTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered w-20" role="document">
                <div class="modal-content">
                    <form @submit.prevent="create_floor">
                        <div class="modal-header">
                            <h5 class="modal-title" id="newFloorTitle">ADDITIONAL FLOOR</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group text-left">
                                <label class="font-weight-bold" for="newFloorPriceRate">Price :</label>
                                <input type="number" id="newFloorPriceRate" class="form-control form-control-sm" placeholder="Ex. 100.00" v-model="newFloor.name" min=0 oninput="validity.valid||(value='');">
                            </div>

                            <div class="form-group text-left">
                                <label class="font-weight-bold" for="newFloorStatus">Status :</label>
                                <input type="checkbox" id="newFloorStatus" class="form-check-label ml-3" placeholder="Status" v-model="newFloor.status">
                                <sup class="ml-3 tnkc-danger-text" v-if="!newFloor.status">* default in-active</sup>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn tnkc-primary">Save changes</button>
                            <button type="button" class="btn tnkc-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- Modal floor -->
        <div class="modal fade" id="floor" tabindex="-1" role="dialog" aria-labelledby="floorTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered w-20" role="document">
                <div class="modal-content">
                    <form @submit.prevent="update_floor">

                        <div class="modal-header">
                            <h5 class="modal-title" id="floorTitle">Update Detail</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="modal-body">
                            <div class="form-group text-left">
                                <label class="font-weight-bold" for="floorPriceRate">Price</label>
                                <input type="number" id="floorPriceRate" class="form-control form-control-sm" placeholder="Ex. 100.00" v-model="floor.price_rate" min=0 oninput="validity.valid||(value='');">
                            </div>

                            <div class="form-group text-left">
                                <label class="font-weight-bold" for="newFloorStatus">Status :</label>
                                <input type="checkbox" id="floorStatus" class="form-check-label ml-3" placeholder="Status" v-model="floor.status" :disabled="rooms == undefined || rooms != ''">
                                <sup class="ml-3 tnkc-success-text" v-if="floor.status">* active</sup>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="submit" class="btn btn-sm tnkc-primary">Update changes</button>
                            <button type="button" class="btn btn-sm tnkc-secondary" data-dismiss="modal">Close</button>
                        </div>

                    </form>
                </div>
            </div>
        </div>

        <!-- Modal add room -->
        <div class="modal fade" id="newRoom" tabindex="-1" role="dialog" aria-labelledby="newRoomTitle" aria-hidden="true">

            <div class="modal-dialog modal-dialog-centered w-20" role="document">
                <div class="modal-content">
                    <form @submit.prevent="create_room">
                        <div class="modal-header">
                            <h5 class="modal-title font-weight-bold" id="newRoomTitle">Add Room</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <!-- details here. -->
                            <div class="form-group text-left">
                                <label class="font-weight-bold" for="newRoomMaxPerson">Max Person :</label>
                                <input type="number" id="newRoomMaxPerson" class="form-control form-control-sm" placeholder="Ex. 3" v-model="newRoom.max_person" min=0 oninput="validity.valid||(value='');">
                            </div>
                            <div class="form-group text-left">
                                <label class="font-weight-bold" for="newRoomStatus">Status :</label>
                                <input type="checkbox" id="newRoomStatus" class="form-check-label ml-3" placeholder="Status" v-model="newRoom.status">
                                <sup class="ml-3 tnkc-danger-text" v-if="!newRoom.status">* default in-active</sup>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn btn-sm tnkc-primary">Save changes</button>
                            <button type="button" class="btn btn-sm tnkc-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </form>
                </div>
            </div>

        </div>

        <!-- Modal  update room -->
        <div class="modal fade" id="room" tabindex="-1" role="dialog" aria-labelledby="roomTitle" aria-hidden="true">

            <div class="modal-dialog modal-dialog-centered w-20" role="document">
                <div class="modal-content">
                    <form @submit.prevent="update_room">
                        <div class="modal-header">
                            <h5 class="modal-title font-weight-bold" id="roomTitle">{{room.name}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <!-- details here. -->
                            <div class="form-group text-left">
                                <label class="font-weight-bold" for="newRoomMaxPerson">Max Person :</label>
                                <input type="number" id="roomMaxPerson" class="form-control form-control-sm" placeholder="Ex. 3" v-model="room.max_person" min=0 oninput="validity.valid||(value='');">
                            </div>
                            <div class="form-group text-left">
                                <label class="font-weight-bold" for="newRoomStatus">Status :</label>
                                <input type="checkbox" id="roomStatus" class="form-check-label ml-3" placeholder="Status" v-model="room.status">
                                <sup class="ml-3" v-bind:class="isActiveOrNot(room.status)">{{room.status ? '* active' : '* default in-active'}}</sup>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn btn-sm tnkc-primary">Save changes</button>
                            <button type="button" class="btn btn-sm tnkc-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </form>
                </div>
            </div>

        </div>

        <!-- Modal  create bed -->
        <div class="modal fade" id="newBed" tabindex="-1" role="dialog" aria-labelledby="newBedTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered w-20" role="document">
                <div class="modal-content">
                    <form @submit.prevent="create_bed">
                        <div class="modal-header">
                            <div class="modal-title font-weight-bold custom-header" id="newBedTitle">Add Bed</div>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <!-- details here. -->
                            <div class="form-group text-left">
                                <label class="font-weight-bold" for="newRoomStatus">Status :</label>
                                <input type="checkbox" id="newBedStatus" class="form-check-label ml-3" placeholder="Status" v-model="newBed.status">
                                <sup class="ml-3" v-bind:class="isActiveOrNot(newBed.status)">{{newBed.status ? '* active' : '* default in-active'}}</sup>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn btn-sm tnkc-primary">Save changes</button>
                            <button type="button" class="btn btn-sm tnkc-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- update bed -->
        <div class="modal fade" id="bed" tabindex="-1" role="dialog" aria-labelledby="bedTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered w-20" role="document">
                <div class="modal-content">
                    <form @submit.prevent="update_bed">
                        <div class="modal-header">
                            <h5 class="modal-title font-weight-bold" id="bedTitle">{{bed.name}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="modal-body">
                            <!-- details here. -->
                            <div class="form-group text-left">
                                <label class="font-weight-bold" for="newRoomStatus">Status :</label>
                                <input type="checkbox" id="bedSta" class="form-check-label ml-3" placeholder="Status" v-model="bed.status">
                                <sup class="ml-3" v-bind:class="isActiveOrNot(bed.status)">{{bed.status ? '* active' : '* default in-active'}}</sup>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="submit" class="btn btn-sm tnkc-primary">Save changes</button>
                            <button type="button" class="btn btn-sm tnkc-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import {appMixins} from '../../../../mixins/app.mixins';

  export default {
    name: 'Hotel',
    props: ['id'],
    mixins: [appMixins],
    data() {
      return {
        //todo
        hotelId: this.id,
        floorId: Number,
        roomId: Number,
        bedId: Number,
      };
    },
    //methods
    methods: {
      ...mapActions(
          [
            'getHotelFloors',
            'createFloor',
            'viewFloor',
            'updateFloor',
            'getFloorRooms',
            'createRoom',
            'setNull',
            'updateRoom',
            'viewRoom',
            'getBedRooms',
            'createBed',
            'updateBed',
            'viewBed',
            'setNullBed',
            'setNullRoom',
            'getAllHotelFloors',
            'deleteBed',
            'createPentHouse'
          ],
      ),

      async create_floor() {
        let msg = 'Are you sure you want to add this record';
        let actionType = 'Create Floor';
        if (await this.questionAlert(msg, actionType)) {
          this.newFloor.hotel_id = this.hotelId;  // set the hotel_id for the current hotel id
          this.createFloor(this.newFloor).then((res) => {
            if (res) {
              this.successAlert('Creating Floor Record Successfully');
            }
          });
        }
      },

      async update_floor() {
        let msg = 'Are you sure you want to update this record?';
        let actionType = 'Update Floor';
        if (await this.questionAlert(msg, actionType)) {
          this.updateFloor(this.floor).then((res) => {
            if (res) {
              this.successAlert('Update record successfully');
              this.getAllHotelFloors();
            }
          });
        }
      },

      isActiveOrNot(object) {
        return object ? 'text-success' : 'text-danger';
      },
      isActiveOrNotCard(object) {
        return object ? '' : 'tnkc-danger';
      },

      getFloorDetails(id) {
        this.get_floor_rooms(id);
        this.viewFloor(id);
      },

      setFloorPriceRate() {
        if (this.floor.price_rate != null) {
          return;
        } else if (this.floor.price_rate == null) {
          return this.floor.price_rate = 0;
        }
      },

      get_floor_rooms(id) {
        // this.floorId = id;cfvdx
        this.setNullBed();
        this.getFloorRooms({id: id});
      },

      async create_room() {
        //proceed to create room
        let msg = 'Are you sure you want to add new room record';
        if (await this.questionAlert(msg)) {
          this.newRoom.hotel_id = this.hotelId;
          this.newRoom.floor_id = this.floor.id;
          this.createRoom(this.newRoom).then((res) => {
            if (res == true) {
              this.successAlert('Record added successfully');
            }
          });
        }
      },

      view_room(id) {
        //return view room
        this.get_bed_rooms(id);
        this.viewRoom({id:id});
      },

      //create bed
     async create_bed(){
        let msg = 'Are you sure you want to add bed';
        let actionType = 'Create Bed';
        if(await this.questionAlert(msg,actionType)){
          this.newBed.hotel_id = this.hotelId;
          this.newBed.room_id = this.room.id;
          this.newBed.floor_id = this.floor.id;
          this.createBed(this.newBed).then((res)=>{
            if(res == true){
              this.successAlert('Successfully Created');
            }
          });
        }
      },

      //view bed
      view_bed(id){
        this.viewBed({id: id});
      },

      //update bed
     async update_bed(){
        // this.bed.hotel_id = this.hotelId;
        // this.bed.floor_id = this.floor.id;
        // this.bed.hotel_
        let msg = 'Are you sure you want to add bed';
        let actionType = 'Update Bed';
        if(await this.questionAlert(msg,actionType)){
          this.updateBed(this.bed).then((res)=>{
            if(res == true){
              this.successAlert('Successfully Updated.');
            }
          });
        }
      },

      //delete bed
      async delete_bed(obj){
        if(await this.questionAlert('Are you sure you want to delete this. ?','Delete Bed','error')){
          this.deleteBed(obj).then((res)=>{
            if(res == true){
              this.successAlert('Bed Record delete successfully');
            }
          })
        }
      },

      get_bed_rooms(id){
        this.getBedRooms({id : id});
      },


   async update_room() {
        //proceed to update room
        let msg = 'Are you sure you want to udpate this record';
        let actionType = 'Update Room';
        if (await this.questionAlert(msg, actionType)) {
          this.updateRoom(this.room).then((res)=>{
            if(res == true){
              this.successAlert('Update Successfully');
            }
          });
        }
      },

     async create_pent_house(){
        if(await this.questionAlert('Are you sure you want to create pent house floor')){
         await this.createPentHouse( this.hotelId).then((res)=>{
           if(res == true){
             //todo;
             this.successAlert('Floor Create Successfully');
           }
         });
        }
      }
    },

    //computed
    computed: {
      ...mapGetters(['floors', 'floor', 'rooms', 'room', 'beds', 'bed', 'newFloor', 'newRoom','newBed']), //newBed

      setFloorScrollable() {
        if (this.floors != undefined && this.floors.length >= 9) {
          return 'con-scrollable';
        }
      },

      setRoomScrollable() {
        if (this.rooms != undefined && this.rooms.length >= 9) {
          return 'con-scrollable';
        }
      },

      setBedRoomScrollable(){
        if (this.beds != undefined && this.beds.length >= 9) {
          return 'con-scrollable';
        }
      }
    },

    //created
    created() {
      this.getHotelFloors(this.id);
      this.setFloorPriceRate();
    },

    //mounted
    mounted() {
      // this.getFloorRooms(this.floorId);
    },


    destroyed() {
      this.setNullBed();
    }
  };
</script>

<style scoped>
    input[type=checkbox] {
        transform: scale(2);
    }

    .w-20 {
        width: 20%;
    }

    .con-scrollable {
        overflow-y: scroll;
        overflow-x: hidden;
        height: 450px;
        padding: 0;
        margin-right: 0;

    }
</style>
